import debounce from 'lodash/debounce'
import React, { useEffect, useState } from 'react'
import { ROUTES } from '@constants/index'
import { drawerEventEmitter } from '@utils/drawerEventEmitter'
import { useSessionInfo } from '@hooks/useSessionInfo'
import { useCreateClaimRecord } from '@hooks/useCreateClaimRecord'
import { LoadingSkeleton } from './LoadingSkeleton/LoadingSkeleton'

export const StartRedirect: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { isAuthenticated, isSessionReady, isSessionInitializing, isRestricted } = useSessionInfo()
  const { createClaimRecord } = useCreateClaimRecord()

  useEffect(() => {
    if (!isAuthenticated || !isSessionReady || isLoading || isRestricted) return

    const debouncedHandler = debounce(() => {
      setIsLoading(true)
      createClaimRecord()
        .then(claimRecord => {
          drawerEventEmitter.openDrawer({ target: ROUTES.RESUME, navigateState: { claimRecordId: claimRecord?.id } })
        })
        .catch(() => setIsLoading(false))
    })

    debouncedHandler()
    return () => debouncedHandler.cancel()
  }, [createClaimRecord, isAuthenticated, isSessionReady, isLoading, isRestricted])

  if (isLoading || isSessionInitializing) {
    return <LoadingSkeleton />
  }

  return null
}
